import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const JupiterIcon = ({
  title = 'Jupiter',
  className,
  ...restProps
}: SVGProps): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-current', className)}
      fill="none"
      viewBox="0 0 84 84"
      {...restProps}
    >
      <title>{title}</title>
      <path
        fill="url(#paint0_linear_15082_1361)"
        d="M8.767 65.622a42.35 42.35 0 0 0 29.946 17.394c-3.054-4.595-7.493-8.823-13.034-12.041s-11.41-4.977-16.912-5.353"
      />
      <path
        fill="url(#paint1_linear_15082_1361)"
        d="M33.125 58.159c-10.676-6.203-22.231-7.783-30.5-4.99a42.5 42.5 0 0 0 3.144 7.626c7.184-.167 15.027 1.784 22.325 6.023 7.298 4.24 12.88 10.09 16.296 16.413a42.8 42.8 0 0 0 8.187-1.048c-1.672-8.564-8.779-17.82-19.452-24.024"
      />
      <path
        fill="url(#paint2_linear_15082_1361)"
        d="M84 32.983a42.316 42.316 0 0 0-52.67-30.6C40.466 3.5 50.606 6.93 60.55 12.708 70.497 18.486 78.506 25.595 84 32.983"
      />
      <path
        fill="url(#paint3_linear_15082_1361)"
        d="M70.708 53.231C66.03 45.465 58.02 38.03 48.152 32.296s-20.294-9.008-29.35-9.224c-7.965-.189-13.944 2.127-16.398 6.352-.014.025-.034.049-.05.074-.22.792-.41 1.586-.583 2.383 3.426-1.353 7.397-2.107 11.812-2.19 9.818-.185 20.806 2.956 30.945 8.846 10.14 5.891 18.317 13.884 23.018 22.501 2.108 3.883 3.423 7.705 3.944 11.357a40 40 0 0 0 1.78-1.685c.015-.027.025-.055.04-.083 2.454-4.229 1.505-10.568-2.603-17.396"
      />
      <path
        fill="url(#paint4_linear_15082_1361)"
        d="M40.644 45.217C25.532 36.437 8.833 35.062.802 41.19a42 42 0 0 0 .439 5.73A33.3 33.3 0 0 1 8.5 45.575c8.974-.675 18.867 1.825 27.845 7.044S52.401 65.197 56.261 73.32a33 33 0 0 1 2.426 6.971c1.786-.7 3.523-1.52 5.198-2.456 1.344-10.012-8.124-23.838-23.24-32.619"
      />
      <path
        fill="url(#paint5_linear_15082_1361)"
        d="M78.48 40.232c-4.729-7.758-12.81-15.215-22.748-20.986-9.938-5.77-20.404-9.097-29.489-9.364-6.925-.2-12.288 1.479-15.07 4.65 11.548-1.957 26.78 1.332 41.545 9.909 14.764 8.577 25.17 20.182 29.187 31.183 1.376-3.985.179-9.476-3.424-15.392"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15082_1361"
          x1="56.207"
          x2="17.982"
          y1="17.519"
          y2="83.231"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15082_1361"
          x1="56.207"
          x2="17.982"
          y1="17.519"
          y2="83.231"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_15082_1361"
          x1="56.207"
          x2="17.982"
          y1="17.519"
          y2="83.231"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_15082_1361"
          x1="56.207"
          x2="17.982"
          y1="17.519"
          y2="83.232"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_15082_1361"
          x1="56.207"
          x2="17.982"
          y1="17.518"
          y2="83.231"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_15082_1361"
          x1="56.207"
          x2="17.982"
          y1="17.518"
          y2="83.231"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
